import { cardBrandDataMap } from '../constants';

type BrandDisplayName =
  | (typeof cardBrandDataMap)[keyof typeof cardBrandDataMap]['display']
  | string;

/**
 * Generate human readable card type from the given card type string, for
 * display in the UI.
 *
 * ### Examples
 * ```
 * getCardBrandDisplayName('master');
 * // => 'MasterCard'
 *
 * getCardBrandDisplayName('MasterCard');
 * // => 'MasterCard'
 *
 * getCardBrandDisplayName('silly card');
 * // => 'Silly card'
 * ```
 */
export const getCardBrandDisplayName = (
  cardType?: string,
): BrandDisplayName => {
  if (!cardType) return 'Unknown';

  const cardTypeLc = cardType.toLowerCase();

  // Find the card type in the human-readable map
  const cardTypeHR = cardBrandDataMap?.[cardTypeLc];
  if (cardTypeHR) return cardTypeHR.display;

  // Fallback to capitalizing the first letter of the card type
  return cardType.charAt(0).toUpperCase() + cardType.slice(1);
};
